import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import {
  filter,
  remove,
} from '../../redux/actions/mallaActions';
import Confirm from '../../shared/components/Confirm';
import { createErrorMessage, createSuccessMessage } from '../../helpers/notification';

class MallasContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 20 },
    };
    this.columns = [
      {
        key: 'id',
        name: '# ',
        search: false,
        width: '80px',
      },
      {
        key: 'nombre',
        name: 'Nombre',
        search: false,
      },
      {
        key: 'carrera',
        name: 'Carrera',
        search: true,
      },
      {
        key: 'fechaVigencia',
        name: 'Fecha Vigencia',
        search: true,
        type: 'date',
        format: (row) => {
          const style = { dateStyle: 'short', timeStyle: 'medium' };
          return new Intl.DateTimeFormat('en-GB', style).format(new Date(row.fechaVigencia));
        },
      },
      {
        key: 'usarPorDefecto',
        name: 'Usar Por Defecto',
        search: false,
        format: row => (row.usarPorDefecto ? 'Si' : 'No'),
      },
      {
        key: 'activo',
        name: 'Activo',
        search: false,
        format: row => (row.activo ? 'Si' : 'No'),
      },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar malla" />,
        callback: (malla) => {
          this.editMalla(malla);
        },
      },
      {
        key: 'delete',
        icon: <span className="fa fa-trash" title="Borrar malla" />,
        callback: (malla) => {
          this.handleDeleteMalla(malla);
        },
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateMallasTable(page, pageSize);
  }

  updateMallasTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    filter({
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de mallas');
      },
    });
  }

  handleDeleteMalla = (malla) => {
    const name = `${malla.nombre} - ${malla.carrera}`;
    Confirm({
      title: 'Borrar malla',
      question: `Estás seguro que deseas eliminar la malla ${name}?`,
      yesLabel: 'Si, Borrar malla',
      noLabel: 'No, Volver',
      onConfirm: () => {
        remove(malla.id, {
          onSuccess: () => {
            createSuccessMessage('Malla borrada exitosamente');
            const { page, pageSize } = this.state;
            this.updateMallasTable(page, pageSize);
          },
          onError: (error) => {
            if (error && error.status === 404) {
              createErrorMessage('El malla no existe');
            } else {
              createErrorMessage('Error al intentar borrar la malla');
            }
          },
        });
      },
    });
  };

  editMalla = (malla) => {
    const { history } = this.props;
    history.push(`/pages/mallas/edit/${malla.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateMallasTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateMallasTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateMallasTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Lista de mallas</h3>
            {false && (
              <div className="card__title">
                <Link className="btn btn-primary" to="/pages/mallas/new">
                  <i className="fa fa-plus" /> Agregar nueva malla
                </Link>
              </div>
            )}
          </Col>
        </Row>
        <Row>
          {loading ? <Col md={12}><h3 className="page-subhead subhead">Cargando...</h3></Col>
            : (
              <DataTable
                title="Listado de todas las mallas"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(MallasContainer);
